import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';

import styles from './project-bundle-confirmation-modal.css';

const ProjectBundleConfirmationModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={
            <FormattedMessage
                defaultMessage="Gem med model"
                description="Titel på bekræftelsesvindue før projekt gemmes med modeldata"
                id="gui.projectBundleConfirmation.title"
            />
        }
        headerClassName={styles.header}
        id="projectBundleConfirmation"
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <p className={styles.lead}>
                <FormattedMessage
                    defaultMessage={
                        'Er du sikker på, at du vil gemme på din computer med model? ' +
                        'Når du gør det, bliver træningsbillederne også gemt i filen.'
                    }
                    description="Forklaring før brugeren gemmer et projekt med modeldata"
                    id="gui.projectBundleConfirmation.lead"
                />
            </p>

            <div className={styles.noticeBox}>
                <p className={styles.noticeTitle}>
                    <FormattedMessage
                        defaultMessage="Vigtigt om billeder og privatliv"
                        description="Børnevenlig GDPR-overskrift i gem-med-model popup"
                        id="gui.projectBundleConfirmation.privacyTitle"
                    />
                </p>
                <p className={styles.noticeText}>
                    <FormattedMessage
                        defaultMessage={
                            'Brug ikke billeder med personfølsomme oplysninger. ' +
                            'Det betyder billeder eller ting, som kan fortælle meget privat om dig eller andre.'
                        }
                        description="Børnevenlig GDPR-forklaring i gem-med-model popup"
                        id="gui.projectBundleConfirmation.privacyText"
                    />
                </p>
                <ul className={styles.exampleList}>
                    <li>
                        <FormattedMessage
                            defaultMessage="ansigter eller tydelige billeder af dig selv eller andre"
                            description="Eksempel på personfølsomme data i gem-med-model popup"
                            id="gui.projectBundleConfirmation.exampleFaces"
                        />
                    </li>
                    <li>
                        <FormattedMessage
                            defaultMessage="fulde navne, adresse, telefonnummer eller skole"
                            description="Eksempel på personfølsomme data i gem-med-model popup"
                            id="gui.projectBundleConfirmation.exampleContact"
                        />
                    </li>
                    <li>
                        <FormattedMessage
                            defaultMessage={
                                'sundhedsoplysninger, CPR-nummer eller andre meget private oplysninger'
                            }
                            description="Eksempel på personfølsomme data i gem-med-model popup"
                            id="gui.projectBundleConfirmation.exampleSensitive"
                        />
                    </li>
                </ul>
            </div>

            <p className={styles.footerText}>
                <FormattedMessage
                    defaultMessage={
                        'Gem kun billeder, som du har lov til at bruge, ' +
                        'og som det er okay at have liggende på computeren.'
                    }
                    description="Afsluttende hjælpetekst i gem-med-model popup"
                    id="gui.projectBundleConfirmation.footer"
                />
            </p>

            <div className={styles.buttonRow}>
                <button
                    className={styles.cancelButton}
                    onClick={props.onCancel}
                    type="button"
                >
                    <FormattedMessage
                        defaultMessage="Nej, ikke endnu"
                        description="Annullerknap i gem-med-model popup"
                        id="gui.projectBundleConfirmation.cancel"
                    />
                </button>
                <button
                    className={styles.confirmButton}
                    onClick={props.onConfirm}
                    type="button"
                >
                    <FormattedMessage
                        defaultMessage="Ja, gem filen"
                        description="Bekræftelsesknap i gem-med-model popup"
                        id="gui.projectBundleConfirmation.confirm"
                    />
                </button>
            </div>
        </Box>
    </Modal>
);

ProjectBundleConfirmationModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default ProjectBundleConfirmationModal;
